import * as React from 'react';
import { ModalContainer, LabelButton } from '@teamsnap/snap-ui';
import e from 'express';

const CloseWarning = ({
  onClose,
  onConfirm,
  isOpen,
}: {
  onClose: () => void;
  onConfirm: () => void;
  isOpen: boolean;
}) => (
  <ModalContainer isOpen={isOpen} onClose={onClose}>
    <div className="sui-heading-sm sui-mb-2">Are you sure?</div>
    <div className="sui-body sui-mb-2">
      Closing will lose all unsaved changes.
    </div>
    <div className="sui-flex sui-justify-end sui-gap-1">
      <LabelButton variantType="secondary" onClick={onConfirm}>
        Discard and exit
      </LabelButton>
      <LabelButton variantType="primary" onClick={onClose}>
        Keep editing
      </LabelButton>
    </div>
  </ModalContainer>
);
export default CloseWarning;
